// src/pages/SelectProgramPage.js
import React, { useState, useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom'; // Added useNavigate
import apiClient from '../api'; // Your configured axios instance
import { useProgram } from '../context/ProgramContext'; // Import the custom hook
import '../styles/SelectProgramPage.css'; // We'll create this CSS file next
import defaultProgramIcon from '../assets/icons/default-program-icon.svg'; // Add a default icon

// Component to display a single program
const ProgramCard = ({ program, onSelect }) => {
    let iconSrc = defaultProgramIcon; // Default if no logo_url

    if (program.logo_url) {
        // Check if logo_url is already an absolute URL (e.g., from a CDN in the future)
        if (program.logo_url.startsWith('http://') || program.logo_url.startsWith('https://')) {
            iconSrc = program.logo_url;
        } else {
            // Prepend the API base URL from your apiClient instance
            // apiClient.defaults.baseURL should be 'http://127.0.0.1:8000'
            iconSrc = `${apiClient.defaults.baseURL}${program.logo_url}`;
        }
    }

    const handleSelect = () => {
        onSelect(program); // Pass the whole program object up
    };

    return (
        <div className="program-card" onClick={handleSelect}>
            <img src={iconSrc} alt={`${program.name} logo`} className="program-icon" />
            <div className="program-info">
                <h3 className="program-name">{program.name}</h3>
                <p className="program-short-name">{program.short_name}</p>
            </div>
        </div>
    );
};

// // Component to display a single program
// const ProgramCard = ({ program, onSelect }) => {
//     // Use program.logo_url if available, otherwise use default icon
//     const iconSrc = program.logo_url || defaultProgramIcon;

//     const handleSelect = () => {
//         onSelect(program); // Pass the whole program object up
//     };

//     return (
//         <div className="program-card" onClick={handleSelect}>
//             <img src={iconSrc} alt={`${program.name} logo`} className="program-icon" />
//             <div className="program-info">
//                 <h3 className="program-name">{program.name}</h3>
//                 <p className="program-short-name">{program.short_name}</p>
//             </div>
//             {/* Add a visual indicator for selection later if needed */}
//         </div>
//     );
// };


// Main Page Component
const SelectProgramPage = ({ isAuthenticated }) => {
    const [programs, setPrograms] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState('');
    const { selectedProgram, setSelectedProgram } = useProgram(); // Get context state and setter
    const navigate = useNavigate(); // Hook for navigation

    useEffect(() => {
        if (!isAuthenticated) {
            setIsLoading(false);
            return; // Don't fetch if not logged in
        }

        const fetchPrograms = async () => {
            setIsLoading(true);
            setError('');
            try {
                console.log("SelectProgramPage: Fetching programs...");
                const response = await apiClient.get('/programs');
                console.log("SelectProgramPage: Programs received:", response.data);
                setPrograms(response.data || []); // Ensure it's always an array
            } catch (err) {
                console.error("SelectProgramPage: Error fetching programs:", err);
                const errorMsg = err.response?.data?.detail || err.message || 'Failed to load programs.';
                setError(errorMsg);
                setPrograms([]); // Clear programs on error
            } finally {
                setIsLoading(false);
            }
        };

        fetchPrograms();
    }, [isAuthenticated]); // Re-fetch if auth status changes

    const handleProgramSelect = (program) => {
        console.log("SelectProgramPage: Program selected:", program);
        setSelectedProgram(program); // Update the global context state
        // Optional: Navigate to Manage Program page after selection
        navigate('/manage-program');
    };

    // Redirect if not authenticated
    if (!isAuthenticated && !isLoading) { // Check isLoading to prevent redirect during initial load
        return <Navigate to="/dashboard" replace />;
    }

    return (
        <div className="select-program-container">
            <h2>Select a Program</h2>
            <p>Choose the loyalty program you want to manage.</p>

            {isLoading && <p className="loading-message">Loading programs...</p>}
            {error && <p className="error-message">Error: {error}</p>}

            {!isLoading && !error && programs.length === 0 && (
                <p className="info-message">You haven't created any programs yet. <a href="/setup-program">Create one now!</a></p>
            )}

            {!isLoading && !error && programs.length > 0 && (
                <div className="program-list">
                    {programs.map(program => (
                        <ProgramCard
                            key={program.id}
                            program={program}
                            onSelect={handleProgramSelect}
                        />
                    ))}
                </div>
            )}

            {/* Display currently selected program (for debugging/confirmation) */}
            {selectedProgram && (
                 <div className="currently-selected-info">
                    Currently managing: <strong>{selectedProgram.name} ({selectedProgram.short_name})</strong>
                 </div>
            )}
        </div>
    );
};

export default SelectProgramPage;